export default __webpack_public_path__ + "static/media/armourer.140b3182.webp";